class PushCartUpsells extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['element-to-update']
  }

  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
  }

  async onCartChanged (event) {
    const state = event?.detail?.state
    const items = state?.items
    const isFullCart =
      Array.isArray(items) &&
      (Object.prototype.hasOwnProperty.call(state, 'item_count') ||
        Object.prototype.hasOwnProperty.call(state, 'token'))

    if (isFullCart) {
      this.setUpdatedProductIds(this.uniqueProductIds(items))
      return
    }

    try {
      const cart = await fetch('/cart.js').then(response => response.json())
      this.setUpdatedProductIds(this.uniqueProductIds(cart.items || []))
    } catch (error) {
      console.error(error)
    }
  }

  uniqueProductIds (items) {
    const ids = []

    for (const item of items) {
      const id = String(item.product_id || '')
      if (!id || ids.includes(id)) continue
      ids.push(id)
      if (ids.length === 3) break
    }

    return ids
  }

  setUpdatedProductIds (productIds) {
    const nextValue = productIds.join(',')
    const target = this.els['element-to-update'].element
    if (target.getAttribute('data-product-id') === nextValue) return
    target.setAttribute('data-product-id', nextValue)
  }
}

if (!customElements.get('push-cart-upsells')) {
  customElements.define('push-cart-upsells', PushCartUpsells)
}
